const E = {
  'Search Users': 'Search Users',
  UserName: 'User Name',
  CellPhone: 'Cell Phone Number',
  PasswordExpiryDate: 'Password Expiry Date',
  LoginAs: 'Login As',

  // LoginAsAdmin Mobile
  'Login As Admin': 'Login As Admin',
  Email: 'Email',
  'Phone Number': 'Phone Number',
  'Password Expiry Date': 'Password Expiry Date',
  'Enter Criteria (Name, UserName or ID)': 'Enter Criteria (Name, UserName or ID)',
};

const F = {
  'Search Users': 'Rechercher des utilisateurs',
  UserName: 'Nom d’utilisateur',
  CellPhone: 'Cellulaire',
  PasswordExpiryDate: 'Expiration du mot de passe',
  LoginAs: 'Se connecter en tant que',

  // LoginAsAdmin Mobile
  'Login As Admin': 'Connexion en tant qu’administrateur',
  Email: 'Adresse courriel',
  'Phone Number': 'Téléphone',
  'Password Expiry Date': 'Date d\'expiration du mot de passe',
  'Enter Criteria (Name, UserName or ID)': 'Entrer les critères (nom, nom d’utilisateur ou identifiant)',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/loginAsAdmin.js